import {
  LockFreeLinkedListNode18403qmazubk5 as LockFreeLinkedListNode,
  LockFreeLinkedListHeaduwhs9comnpmn as LockFreeLinkedListHead,
} from './internal/LinkedList.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import {
  get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName,
  get_hexAddress1mxa7txdmiojm as get_hexAddress,
  get_DEBUG1a8uv2i5oid01 as get_DEBUG,
} from './Debug.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally } from './CompletionState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from './Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException } from './Timeout.mjs';
import { identitySet1lu9dl60optk8 as identitySet } from './internal/Concurrent.mjs';
import { unwrap34f7x4f5snsxt as unwrap } from './internal/StackTraceRecovery.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  NonDisposableHandle_instance1i3r88cx0n1ry as NonDisposableHandle_instance,
  invokeOnCompletion3npqdfp2wzhn6 as invokeOnCompletion,
  ParentJob1a3idoswyjefg as ParentJob,
  Key_instancepi2bbb0csu5f as Key_instance,
  ensureActive2yo7199srjlgl as ensureActive,
  cancel$default18ta0nr79mwbn as cancel$default,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { CompletionHandlerException1h8udyjlr1wky as CompletionHandlerException } from './Exceptions.common.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  anyToString3ho3k49fc56mj as anyToString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './CancellableContinuationImpl.mjs';
import { disposeOnCancellation302lv5bib5mna as disposeOnCancellation } from './CancellableContinuation.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { SynchronizedObject32xqzf15iiskd as SynchronizedObject } from './internal/Synchronized.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from '../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  plusolev77jfy5r9 as plus,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
} from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './internal/Symbol.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
var JobNodeClass;
function JobNode() {
  if (JobNodeClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      get_job_18j2r0_k$() {
        var tmp = this.job_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('job');
        }
      }
      get_isActive_quafmh_k$() {
        return true;
      }
      get_list_wopuqv_k$() {
        return null;
      }
      dispose_3nnxhr_k$() {
        return this.get_job_18j2r0_k$().removeNode_qrwaz_k$(this);
      }
      toString() {
        return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.get_job_18j2r0_k$()) + ']';
      }
    }
    initMetadataForClass($, 'JobNode', VOID, VOID, [Incomplete()]);
    JobNodeClass = $;
  }
  return JobNodeClass;
}
function _set_exceptionsHolder__tqm22h($this, value) {
  $this._exceptionsHolder_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this._exceptionsHolder_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(4);
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally() ? proposedUpdate : null;
  var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cause_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  wasCancelling = state.get_isCancelling_o1apv_k$();
  var exceptions = state.sealLocked_m2r6b3_k$(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new (CompletedExceptionally())(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.handleJobException_9fdet1_k$(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally() ? finalState : THROW_CCE()).makeHandled_ws9oq6_k$();
    }
  }
  if (!wasCancelling) {
    $this.onCancelling_aqzbl5_k$(finalException);
  }
  $this.onCompletionInternal_38s8uv_k$(finalState);
  var casSuccess = $this._state_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.isEmpty_y1axqb_k$()) {
    if (state.get_isCancelling_o1apv_k$()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$(null == null ? $this.cancellationExceptionMessage_a64063_k$() : null, null, $this);
    }
    return null;
  }
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = exceptions.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (!(element instanceof CancellationException())) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var firstNonCancellation = tmp$ret$1;
  if (!(firstNonCancellation == null))
    return firstNonCancellation;
  var first = exceptions.get_c1px32_k$(0);
  if (first instanceof TimeoutCancellationException()) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = exceptions.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$3 = null;
    }
    var detailedTimeoutException = tmp$ret$3;
    if (!(detailedTimeoutException == null))
      return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.get_size_woubt6_k$() <= 1)
    return Unit_instance;
  var seenExceptions = identitySet(exceptions.get_size_woubt6_k$());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var exception = _iterator__ex2g4s.next_20eer_k$();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.add_utx5q5_k$(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this._state_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
    return false;
  $this.onCancelling_aqzbl5_k$(null);
  $this.onCompletionInternal_38s8uv_k$(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp0_safe_receiver = $this.get_parentHandle_h80e5u_k$();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.dispose_3nnxhr_k$();
    $this.set_parentHandle_knepiy_k$(NonDisposableHandle_instance);
  }
  var tmp1_safe_receiver = update instanceof CompletedExceptionally() ? update : null;
  var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.cause_1;
  if (state instanceof JobNode()) {
    try {
      state.invoke_py2q9a_k$(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.handleOnCompletionException_l1g6ri_k$(CompletionHandlerException().new_kotlinx_coroutines_CompletionHandlerException_o9da2b_k$('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp2_safe_receiver = state.get_list_wopuqv_k$();
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCompletion($this, tmp2_safe_receiver, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.onCancelling_aqzbl5_k$(cause);
  list.close_ari2z4_k$(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list._next_1;
  while (!equals(cur, list)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode()) {
      tmp = node.get_onCancelling_k07uns_k$();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.invoke_py2q9a_k$(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = CompletionHandlerException().new_kotlinx_coroutines_CompletionHandlerException_o9da2b_k$('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur._next_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.handleOnCompletionException_l1g6ri_k$(tmp0_safe_receiver_0);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.get_isScopedCoroutine_rwmmff_k$())
    return true;
  var isCancellation = cause instanceof CancellationException();
  var parent = $this.get_parentHandle_h80e5u_k$();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.childCancelled_hsnipy_k$(cause) || isCancellation;
}
function notifyCompletion($this, $receiver, cause) {
  $receiver.close_ari2z4_k$(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = $receiver._next_1;
  while (!equals(cur, $receiver)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode()) {
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.invoke_py2q9a_k$(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = CompletionHandlerException().new_kotlinx_coroutines_CompletionHandlerException_o9da2b_k$('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur._next_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.handleOnCompletionException_l1g6ri_k$(tmp0_safe_receiver_0);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty()) {
    if (state.isActive_1)
      return 0;
    if (!$this._state_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
      return -1;
    $this.onStart_qsx7gt_k$();
    return 1;
  } else {
    if (state instanceof InactiveNodeList()) {
      if (!$this._state_1.atomicfu$compareAndSet(state, state.list_1))
        return -1;
      $this.onStart_qsx7gt_k$();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new (NodeList())();
  var update = state.isActive_1 ? list : new (InactiveNodeList())(list);
  $this._state_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.addOneIfEmpty_2jwoix_k$(new (NodeList())());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state._next_1;
  $this._state_1.atomicfu$compareAndSet(state, list);
}
function joinInternal($this) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.get_state_2t6sbp_k$();
    if (!(!(state == null) ? isInterface(state, Incomplete()) : false))
      return false;
    if (startInternal($this, state) >= 0)
      return true;
  }
}
function *joinSuspend($this, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new (ResumeOnCompletion())(cancellable)));
    return cancellable.getResult_fck196_k$();
  });
  return Unit_instance;
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.get_state_2t6sbp_k$();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing()) {
        tmp_0 = state.get_isCompleting_vi2bwp_k$();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new (CompletedExceptionally())(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY()))
      return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$(null == null ? $this.cancellationExceptionMessage_a64063_k$() : null, null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = (isInterface(cause, ParentJob()) ? cause : THROW_CCE()).getChildJobCancellationCause_wx9uoh_k$();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp0 = $this.get_state_2t6sbp_k$();
    $l$block: {
      if (tmp0 instanceof Finishing()) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        if (tmp0.get_isSealed_zdv4z3_k$())
          return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = tmp0.get_isCancelling_o1apv_k$();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          tmp0.addExceptionLocked_hjqo7b_k$(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = tmp0.get_rootCause_69dwxu_k$();
        var tmp_0;
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          notifyCancelling($this, tmp0.list_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(tmp0 == null) ? isInterface(tmp0, Incomplete()) : false) {
          var tmp2_elvis_lhs = causeExceptionCache;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var causeException_0 = tmp_1;
          if (tmp0.get_isActive_quafmh_k$()) {
            if (tryMakeCancelling($this, tmp0, causeException_0))
              return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, tmp0, new (CompletedExceptionally())(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString(tmp0);
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.get_list_wopuqv_k$();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty()) {
      tmp_0 = new (NodeList())();
    } else {
      if (state instanceof JobNode()) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'State should have list: ' + toString(state);
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new (Finishing())(list, false, rootCause);
  if (!$this._state_1.atomicfu$compareAndSet(state, cancelling))
    return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete()) : false))
    return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty()) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode();
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally());
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing() ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new (Finishing())(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.get_isCompleting_vi2bwp_k$())
    return get_COMPLETING_ALREADY();
  finishing.set_isCompleting_1h5iw_k$(true);
  if (!(finishing === state)) {
    if (!$this._state_1.atomicfu$compareAndSet(state, finishing))
      return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.get_isCancelling_o1apv_k$();
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally() ? proposedUpdate : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    finishing.addExceptionLocked_hjqo7b_k$(tmp0_safe_receiver.cause_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.get_rootCause_69dwxu_k$();
  var tmp_0;
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild($this, list);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  list.close_ari2z4_k$(2);
  var anotherChild = nextChild($this, list);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js($this, $receiver) {
  var tmp0_safe_receiver = $receiver instanceof CompletedExceptionally() ? $receiver : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cause_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  $l$1: do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.childJob_1, false, new (ChildCompletion())($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance))
        return true;
      var tmp0_elvis_lhs = nextChild($this_0, child_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_0;
      var tmp1 = state_0;
      var tmp3 = proposedUpdate_0;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = nextChild_0;
      proposedUpdate_0 = tmp3;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild($this, lastChild);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
    return Unit_instance;
  state.list_1.close_ari2z4_k$(2);
  var waitChildAgain = nextChild($this, lastChild);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.afterCompletion_2p0irt_k$(finalState);
}
function nextChild($this, $receiver) {
  var cur = $receiver;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur._removed_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur._prev_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur._next_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur._removed_1)
      continue $l$loop_0;
    if (cur instanceof ChildHandleNode())
      return cur;
    if (cur instanceof NodeList())
      return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing()) {
    tmp = state.get_isCancelling_o1apv_k$() ? 'Cancelling' : state.get_isCompleting_vi2bwp_k$() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete()) : false) {
      tmp = state.get_isActive_quafmh_k$() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally()) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
var FinishingClass;
function Finishing() {
  if (FinishingClass === VOID) {
    class $ extends SynchronizedObject() {
      constructor(list, isCompleting, rootCause) {
        super();
        this.list_1 = list;
        this._isCompleting_1 = atomic$boolean$1(isCompleting);
        this._rootCause_1 = atomic$ref$1(rootCause);
        this._exceptionsHolder_1 = atomic$ref$1(null);
      }
      get_list_wopuqv_k$() {
        return this.list_1;
      }
      set_isCompleting_1h5iw_k$(value) {
        this._isCompleting_1.kotlinx$atomicfu$value = value;
      }
      get_isCompleting_vi2bwp_k$() {
        return this._isCompleting_1.kotlinx$atomicfu$value;
      }
      set_rootCause_zflycc_k$(value) {
        this._rootCause_1.kotlinx$atomicfu$value = value;
      }
      get_rootCause_69dwxu_k$() {
        return this._rootCause_1.kotlinx$atomicfu$value;
      }
      get_isSealed_zdv4z3_k$() {
        return _get_exceptionsHolder__nhszp(this) === get_SEALED();
      }
      get_isCancelling_o1apv_k$() {
        return !(this.get_rootCause_69dwxu_k$() == null);
      }
      get_isActive_quafmh_k$() {
        return this.get_rootCause_69dwxu_k$() == null;
      }
      sealLocked_m2r6b3_k$(proposedException) {
        var eh = _get_exceptionsHolder__nhszp(this);
        var tmp;
        if (eh == null) {
          tmp = allocateList(this);
        } else {
          if (eh instanceof Error) {
            // Inline function 'kotlin.also' call
            var this_0 = allocateList(this);
            this_0.add_utx5q5_k$(eh);
            tmp = this_0;
          } else {
            if (eh instanceof ArrayList()) {
              tmp = eh instanceof ArrayList() ? eh : THROW_CCE();
            } else {
              // Inline function 'kotlin.error' call
              var message = 'State is ' + toString(eh);
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
            }
          }
        }
        var list = tmp;
        var rootCause = this.get_rootCause_69dwxu_k$();
        if (rootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          list.add_dl6gt3_k$(0, rootCause);
        }
        if (!(proposedException == null) && !equals(proposedException, rootCause)) {
          list.add_utx5q5_k$(proposedException);
        }
        _set_exceptionsHolder__tqm22h(this, get_SEALED());
        return list;
      }
      addExceptionLocked_hjqo7b_k$(exception) {
        var rootCause = this.get_rootCause_69dwxu_k$();
        if (rootCause == null) {
          this.set_rootCause_zflycc_k$(exception);
          return Unit_instance;
        }
        if (exception === rootCause)
          return Unit_instance;
        var eh = _get_exceptionsHolder__nhszp(this);
        if (eh == null) {
          _set_exceptionsHolder__tqm22h(this, exception);
        } else {
          if (eh instanceof Error) {
            if (exception === eh)
              return Unit_instance;
            // Inline function 'kotlin.apply' call
            var this_0 = allocateList(this);
            this_0.add_utx5q5_k$(eh);
            this_0.add_utx5q5_k$(exception);
            _set_exceptionsHolder__tqm22h(this, this_0);
          } else {
            if (eh instanceof ArrayList()) {
              (eh instanceof ArrayList() ? eh : THROW_CCE()).add_utx5q5_k$(exception);
            } else {
              // Inline function 'kotlin.error' call
              var message = 'State is ' + toString(eh);
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
            }
          }
        }
      }
      toString() {
        return 'Finishing[cancelling=' + this.get_isCancelling_o1apv_k$() + ', completing=' + this.get_isCompleting_vi2bwp_k$() + ', rootCause=' + toString_0(this.get_rootCause_69dwxu_k$()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.list_1.toString() + ']';
      }
    }
    initMetadataForClass($, 'Finishing', VOID, VOID, [Incomplete()]);
    FinishingClass = $;
  }
  return FinishingClass;
}
var ChildCompletionClass;
function ChildCompletion() {
  if (ChildCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(parent, state, child, proposedUpdate) {
        super();
        this.parent_1 = parent;
        this.state_1 = state;
        this.child_1 = child;
        this.proposedUpdate_1 = proposedUpdate;
      }
      get_onCancelling_k07uns_k$() {
        return false;
      }
      invoke_py2q9a_k$(cause) {
        continueCompleting(this.parent_1, this.state_1, this.child_1, this.proposedUpdate_1);
      }
    }
    initMetadataForClass($, 'ChildCompletion');
    ChildCompletionClass = $;
  }
  return ChildCompletionClass;
}
var AwaitContinuationClass;
function AwaitContinuation() {
  if (AwaitContinuationClass === VOID) {
    class $ extends CancellableContinuationImpl() {
      constructor(delegate, job) {
        super(delegate, 1);
        this.job_1 = job;
      }
      getContinuationCancellationCause_3nurbc_k$(parent) {
        var state = this.job_1.get_state_2t6sbp_k$();
        if (state instanceof Finishing()) {
          var tmp0_safe_receiver = state.get_rootCause_69dwxu_k$();
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            return tmp0_safe_receiver;
          }
        }
        if (state instanceof CompletedExceptionally())
          return state.cause_1;
        return parent.getCancellationException_8i1q6u_k$();
      }
      nameString_cd9e9w_k$() {
        return 'AwaitContinuation';
      }
    }
    initMetadataForClass($, 'AwaitContinuation');
    AwaitContinuationClass = $;
  }
  return AwaitContinuationClass;
}
function *awaitSuspend($this, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cont = new (AwaitContinuation())(intercepted(uCont), $this);
    cont.initCancellability_shqc60_k$();
    disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new (ResumeAwaitOnCompletion())(cont)));
    return cont.getResult_fck196_k$();
  };
}
var JobSupportClass;
function JobSupport() {
  if (JobSupportClass === VOID) {
    class $ {
      constructor(active) {
        this._state_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
        this._parentHandle_1 = atomic$ref$1(null);
      }
      get_key_18j28a_k$() {
        return Key_instance;
      }
      set_parentHandle_knepiy_k$(value) {
        this._parentHandle_1.kotlinx$atomicfu$value = value;
      }
      get_parentHandle_h80e5u_k$() {
        return this._parentHandle_1.kotlinx$atomicfu$value;
      }
      get_parent_hy4reb_k$() {
        var tmp0_safe_receiver = this.get_parentHandle_h80e5u_k$();
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_parent_hy4reb_k$();
      }
      initParentJob_jbhsg3_k$(parent) {
        // Inline function 'kotlinx.coroutines.assert' call
        if (parent == null) {
          this.set_parentHandle_knepiy_k$(NonDisposableHandle_instance);
          return Unit_instance;
        }
        parent.start_1tchgi_k$();
        var handle = parent.attachChild_314ws0_k$(this);
        this.set_parentHandle_knepiy_k$(handle);
        if (this.get_isCompleted_a6j6c8_k$()) {
          handle.dispose_3nnxhr_k$();
          this.set_parentHandle_knepiy_k$(NonDisposableHandle_instance);
        }
      }
      get_state_2t6sbp_k$() {
        return this._state_1.kotlinx$atomicfu$value;
      }
      get_isActive_quafmh_k$() {
        var state = this.get_state_2t6sbp_k$();
        var tmp;
        if (!(state == null) ? isInterface(state, Incomplete()) : false) {
          tmp = state.get_isActive_quafmh_k$();
        } else {
          tmp = false;
        }
        return tmp;
      }
      get_isCompleted_a6j6c8_k$() {
        var tmp = this.get_state_2t6sbp_k$();
        return !(!(tmp == null) ? isInterface(tmp, Incomplete()) : false);
      }
      get_isCancelled_trk8pu_k$() {
        var state = this.get_state_2t6sbp_k$();
        var tmp;
        if (state instanceof CompletedExceptionally()) {
          tmp = true;
        } else {
          var tmp_0;
          if (state instanceof Finishing()) {
            tmp_0 = state.get_isCancelling_o1apv_k$();
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      start_1tchgi_k$() {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var state = this.get_state_2t6sbp_k$();
          var tmp0_subject = startInternal(this, state);
          if (tmp0_subject === 0)
            return false;
          else if (tmp0_subject === 1)
            return true;
        }
      }
      onStart_qsx7gt_k$() {
      }
      getCancellationException_8i1q6u_k$() {
        var state = this.get_state_2t6sbp_k$();
        var tmp;
        if (state instanceof Finishing()) {
          var tmp0_safe_receiver = state.get_rootCause_69dwxu_k$();
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_70r72h_k$(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.error' call
            var message = 'Job is still new or active: ' + this.toString();
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          tmp = tmp_0;
        } else {
          if (!(state == null) ? isInterface(state, Incomplete()) : false) {
            // Inline function 'kotlin.error' call
            var message_0 = 'Job is still new or active: ' + this.toString();
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
          } else {
            if (state instanceof CompletedExceptionally()) {
              tmp = this.toCancellationException$default_r7tnxv_k$(state.cause_1);
            } else {
              tmp = JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$(get_classSimpleName(this) + ' has completed normally', null, this);
            }
          }
        }
        return tmp;
      }
      toCancellationException_70r72h_k$(_this__u8e3s4, message) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException() ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$(message == null ? this.cancellationExceptionMessage_a64063_k$() : message, _this__u8e3s4, this);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      toCancellationException$default_r7tnxv_k$(_this__u8e3s4, message, $super) {
        message = message === VOID ? null : message;
        return $super === VOID ? this.toCancellationException_70r72h_k$(_this__u8e3s4, message) : $super.toCancellationException_70r72h_k$.call(this, _this__u8e3s4, message);
      }
      invokeOnCompletion_n6cffu_k$(handler) {
        return this.invokeOnCompletionInternal_5jxuhy_k$(true, new (InvokeOnCompletion())(handler));
      }
      invokeOnCompletion_sct3wq_k$(onCancelling, invokeImmediately, handler) {
        var tmp;
        if (onCancelling) {
          tmp = new (InvokeOnCancelling())(handler);
        } else {
          tmp = new (InvokeOnCompletion())(handler);
        }
        return this.invokeOnCompletionInternal_5jxuhy_k$(invokeImmediately, tmp);
      }
      invokeOnCompletionInternal_5jxuhy_k$(invokeImmediately, node) {
        node.job_1 = this;
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
          // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
          while (true) {
            var state = this.get_state_2t6sbp_k$();
            if (state instanceof Empty()) {
              if (state.isActive_1) {
                if (this._state_1.atomicfu$compareAndSet(state, node)) {
                  tmp$ret$0 = true;
                  break $l$block_1;
                }
              } else {
                promoteEmptyToNodeList(this, state);
              }
            } else {
              if (!(state == null) ? isInterface(state, Incomplete()) : false) {
                var list = state.get_list_wopuqv_k$();
                if (list == null) {
                  promoteSingleToNodeList(this, state instanceof JobNode() ? state : THROW_CCE());
                } else {
                  var tmp;
                  if (node.get_onCancelling_k07uns_k$()) {
                    var tmp0_safe_receiver = state instanceof Finishing() ? state : null;
                    var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_rootCause_69dwxu_k$();
                    var tmp_0;
                    if (rootCause == null) {
                      tmp_0 = list.addLast_5b0i77_k$(node, 5);
                    } else {
                      if (invokeImmediately) {
                        node.invoke_py2q9a_k$(rootCause);
                      }
                      return NonDisposableHandle_instance;
                    }
                    tmp = tmp_0;
                  } else {
                    tmp = list.addLast_5b0i77_k$(node, 1);
                  }
                  if (tmp) {
                    tmp$ret$0 = true;
                    break $l$block_1;
                  }
                }
              } else {
                tmp$ret$0 = false;
                break $l$block_1;
              }
            }
          }
        }
        var added = tmp$ret$0;
        if (added)
          return node;
        else if (invokeImmediately) {
          var tmp_1 = this.get_state_2t6sbp_k$();
          var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally() ? tmp_1 : null;
          node.invoke_py2q9a_k$(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.cause_1);
        }
        return NonDisposableHandle_instance;
      }
      *join_o20dar_k$($completion) {
        if (!joinInternal(this)) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var tmp$ret$0 = $completion.get_context_h02k06_k$();
          ensureActive(tmp$ret$0);
          return Unit_instance;
        }
        return yield* /*#__NOINLINE__*/joinSuspend(this, $completion);
      }
      removeNode_qrwaz_k$(node) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var state = this.get_state_2t6sbp_k$();
          if (state instanceof JobNode()) {
            if (!(state === node))
              return Unit_instance;
            if (this._state_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
              return Unit_instance;
          } else {
            if (!(state == null) ? isInterface(state, Incomplete()) : false) {
              if (!(state.get_list_wopuqv_k$() == null)) {
                node.remove_fgfybg_k$();
              }
              return Unit_instance;
            } else {
              return Unit_instance;
            }
          }
        }
      }
      get_onCancelComplete_jew0sy_k$() {
        return false;
      }
      cancel_hkmm2i_k$(cause) {
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$(null == null ? this.cancellationExceptionMessage_a64063_k$() : null, null, this);
        } else {
          tmp = cause;
        }
        this.cancelInternal_fraw7c_k$(tmp);
      }
      cancellationExceptionMessage_a64063_k$() {
        return 'Job was cancelled';
      }
      cancelInternal_fraw7c_k$(cause) {
        this.cancelImpl_465b6c_k$(cause);
      }
      parentCancelled_ev6cqi_k$(parentJob) {
        this.cancelImpl_465b6c_k$(parentJob);
      }
      childCancelled_hsnipy_k$(cause) {
        if (cause instanceof CancellationException())
          return true;
        return this.cancelImpl_465b6c_k$(cause) && this.get_handlesException_ctmhwg_k$();
      }
      cancelCoroutine_rpko3c_k$(cause) {
        return this.cancelImpl_465b6c_k$(cause);
      }
      cancelImpl_465b6c_k$(cause) {
        var finalState = get_COMPLETING_ALREADY();
        if (this.get_onCancelComplete_jew0sy_k$()) {
          finalState = cancelMakeCompleting(this, cause);
          if (finalState === get_COMPLETING_WAITING_CHILDREN())
            return true;
        }
        if (finalState === get_COMPLETING_ALREADY()) {
          finalState = makeCancelling(this, cause);
        }
        var tmp;
        if (finalState === get_COMPLETING_ALREADY()) {
          tmp = true;
        } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
          tmp = true;
        } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
          tmp = false;
        } else {
          this.afterCompletion_2p0irt_k$(finalState);
          tmp = true;
        }
        return tmp;
      }
      getChildJobCancellationCause_wx9uoh_k$() {
        var state = this.get_state_2t6sbp_k$();
        var tmp;
        if (state instanceof Finishing()) {
          tmp = state.get_rootCause_69dwxu_k$();
        } else {
          if (state instanceof CompletedExceptionally()) {
            tmp = state.cause_1;
          } else {
            if (!(state == null) ? isInterface(state, Incomplete()) : false) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot be cancelling child in this state: ' + toString(state);
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
            } else {
              tmp = null;
            }
          }
        }
        var rootCause = tmp;
        var tmp1_elvis_lhs = rootCause instanceof CancellationException() ? rootCause : null;
        return tmp1_elvis_lhs == null ? JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
      }
      makeCompleting_fohkwa_k$(proposedUpdate) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var tmp0 = this.get_state_2t6sbp_k$();
          $l$block: {
            var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
            if (finalState === get_COMPLETING_ALREADY())
              return false;
            else if (finalState === get_COMPLETING_WAITING_CHILDREN())
              return true;
            else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else {
              this.afterCompletion_2p0irt_k$(finalState);
              return true;
            }
          }
        }
      }
      makeCompletingOnce_m8ggg9_k$(proposedUpdate) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var tmp0 = this.get_state_2t6sbp_k$();
          $l$block: {
            var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
            if (finalState === get_COMPLETING_ALREADY())
              throw IllegalStateException().new_kotlin_IllegalStateException_z3fz2g_k$('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
            else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        }
      }
      attachChild_314ws0_k$(child) {
        // Inline function 'kotlin.also' call
        var this_0 = new (ChildHandleNode())(child);
        this_0.job_1 = this;
        var node = this_0;
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
          // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
          while (true) {
            var state = this.get_state_2t6sbp_k$();
            if (state instanceof Empty()) {
              if (state.isActive_1) {
                if (this._state_1.atomicfu$compareAndSet(state, node)) {
                  tmp$ret$2 = true;
                  break $l$block_1;
                }
              } else {
                promoteEmptyToNodeList(this, state);
              }
            } else {
              if (!(state == null) ? isInterface(state, Incomplete()) : false) {
                var list = state.get_list_wopuqv_k$();
                if (list == null) {
                  promoteSingleToNodeList(this, state instanceof JobNode() ? state : THROW_CCE());
                } else {
                  var addedBeforeCancellation = list.addLast_5b0i77_k$(node, 7);
                  var tmp;
                  if (addedBeforeCancellation) {
                    tmp = true;
                  } else {
                    var addedBeforeCompletion = list.addLast_5b0i77_k$(node, 3);
                    var latestState = this.get_state_2t6sbp_k$();
                    var tmp_0;
                    if (latestState instanceof Finishing()) {
                      tmp_0 = latestState.get_rootCause_69dwxu_k$();
                    } else {
                      // Inline function 'kotlinx.coroutines.assert' call
                      var tmp0_safe_receiver = latestState instanceof CompletedExceptionally() ? latestState : null;
                      tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cause_1;
                    }
                    var rootCause = tmp_0;
                    node.invoke_py2q9a_k$(rootCause);
                    var tmp_1;
                    if (addedBeforeCompletion) {
                      // Inline function 'kotlinx.coroutines.assert' call
                      tmp_1 = true;
                    } else {
                      return NonDisposableHandle_instance;
                    }
                    tmp = tmp_1;
                  }
                  if (tmp) {
                    tmp$ret$2 = true;
                    break $l$block_1;
                  }
                }
              } else {
                tmp$ret$2 = false;
                break $l$block_1;
              }
            }
          }
        }
        var added = tmp$ret$2;
        if (added)
          return node;
        var tmp_2 = this.get_state_2t6sbp_k$();
        var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally() ? tmp_2 : null;
        node.invoke_py2q9a_k$(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.cause_1);
        return NonDisposableHandle_instance;
      }
      handleOnCompletionException_l1g6ri_k$(exception) {
        throw exception;
      }
      onCancelling_aqzbl5_k$(cause) {
      }
      get_isScopedCoroutine_rwmmff_k$() {
        return false;
      }
      get_handlesException_ctmhwg_k$() {
        return true;
      }
      handleJobException_9fdet1_k$(exception) {
        return false;
      }
      onCompletionInternal_38s8uv_k$(state) {
      }
      afterCompletion_2p0irt_k$(state) {
      }
      toString() {
        return this.toDebugString_v3moy1_k$() + '@' + get_hexAddress(this);
      }
      toDebugString_v3moy1_k$() {
        return this.nameString_4rfuxd_k$() + '{' + stateString(this, this.get_state_2t6sbp_k$()) + '}';
      }
      nameString_4rfuxd_k$() {
        return get_classSimpleName(this);
      }
      getCompletedInternal_tfzdln_k$() {
        var state = this.get_state_2t6sbp_k$();
        // Inline function 'kotlin.check' call
        if (!!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
          var message = 'This job has not completed yet';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if (state instanceof CompletedExceptionally())
          throw state.cause_1;
        return unboxState(state);
      }
      *awaitInternal_5d94r6_k$($completion) {
        $l$loop: while (true) {
          var state = this.get_state_2t6sbp_k$();
          if (!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
            if (state instanceof CompletedExceptionally()) {
              // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
              throw state.cause_1;
            }
            return unboxState(state);
          }
          if (startInternal(this, state) >= 0)
            break $l$loop;
        }
        return yield* /*#__NOINLINE__*/awaitSuspend(this, $completion);
      }
    }
    protoOf($).cancel$default_8haxne_k$ = cancel$default;
    protoOf($).plus_s13ygv_k$ = plus;
    protoOf($).get_y2st91_k$ = get;
    protoOf($).fold_j2vaxd_k$ = fold;
    protoOf($).minusKey_9i5ggf_k$ = minusKey;
    initMetadataForClass($, 'JobSupport', VOID, VOID, [Job(), ParentJob()], [0]);
    JobSupportClass = $;
  }
  return JobSupportClass;
}
function handlesExceptionF($this) {
  var tmp = $this.get_parentHandle_h80e5u_k$();
  var tmp0_safe_receiver = tmp instanceof ChildHandleNode() ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_job_18j2r0_k$();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.get_handlesException_ctmhwg_k$())
      return true;
    var tmp_1 = parentJob.get_parentHandle_h80e5u_k$();
    var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode() ? tmp_1 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.get_job_18j2r0_k$();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
var JobImplClass;
function JobImpl() {
  if (JobImplClass === VOID) {
    class $ extends JobSupport() {
      constructor(parent) {
        super(true);
        this.initParentJob_jbhsg3_k$(parent);
        this.handlesException_1 = handlesExceptionF(this);
      }
      get_onCancelComplete_jew0sy_k$() {
        return true;
      }
      get_handlesException_ctmhwg_k$() {
        return this.handlesException_1;
      }
    }
    initMetadataForClass($, 'JobImpl', VOID, VOID, [Job()], [0]);
    JobImplClass = $;
  }
  return JobImplClass;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      constructor(isActive) {
        this.isActive_1 = isActive;
      }
      get_isActive_quafmh_k$() {
        return this.isActive_1;
      }
      get_list_wopuqv_k$() {
        return null;
      }
      toString() {
        return 'Empty{' + (this.isActive_1 ? 'Active' : 'New') + '}';
      }
    }
    initMetadataForClass($, 'Empty', VOID, VOID, [Incomplete()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var IncompleteClass;
function Incomplete() {
  if (IncompleteClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Incomplete');
    IncompleteClass = $;
  }
  return IncompleteClass;
}
var NodeListClass;
function NodeList() {
  if (NodeListClass === VOID) {
    class $ extends LockFreeLinkedListHead() {
      get_isActive_quafmh_k$() {
        return true;
      }
      get_list_wopuqv_k$() {
        return this;
      }
      getString_gb1pt9_k$(state) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this_0.append_22ad7x_k$('List{');
        this_0.append_22ad7x_k$(state);
        this_0.append_22ad7x_k$('}[');
        var first = true;
        // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
        var cur = this._next_1;
        while (!equals(cur, this)) {
          var node = cur;
          if (node instanceof JobNode()) {
            if (first) {
              first = false;
            } else
              this_0.append_22ad7x_k$(', ');
            this_0.append_t8pm91_k$(node);
          }
          cur = cur._next_1;
        }
        this_0.append_22ad7x_k$(']');
        return this_0.toString();
      }
      toString() {
        return get_DEBUG() ? this.getString_gb1pt9_k$('Active') : super.toString();
      }
    }
    initMetadataForClass($, 'NodeList', NodeList, VOID, [Incomplete()]);
    NodeListClass = $;
  }
  return NodeListClass;
}
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete()) : false) {
    tmp = new (IncompleteStateBox())(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
var InactiveNodeListClass;
function InactiveNodeList() {
  if (InactiveNodeListClass === VOID) {
    class $ {
      constructor(list) {
        this.list_1 = list;
      }
      get_list_wopuqv_k$() {
        return this.list_1;
      }
      get_isActive_quafmh_k$() {
        return false;
      }
      toString() {
        return get_DEBUG() ? this.list_1.getString_gb1pt9_k$('New') : anyToString(this);
      }
    }
    initMetadataForClass($, 'InactiveNodeList', VOID, VOID, [Incomplete()]);
    InactiveNodeListClass = $;
  }
  return InactiveNodeListClass;
}
var InvokeOnCompletionClass;
function InvokeOnCompletion() {
  if (InvokeOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(handler) {
        super();
        this.handler_1 = handler;
      }
      get_onCancelling_k07uns_k$() {
        return false;
      }
      invoke_py2q9a_k$(cause) {
        return this.handler_1(cause);
      }
    }
    initMetadataForClass($, 'InvokeOnCompletion');
    InvokeOnCompletionClass = $;
  }
  return InvokeOnCompletionClass;
}
var InvokeOnCancellingClass;
function InvokeOnCancelling() {
  if (InvokeOnCancellingClass === VOID) {
    class $ extends JobNode() {
      constructor(handler) {
        super();
        this.handler_1 = handler;
        this._invoked_1 = atomic$boolean$1(false);
      }
      get_onCancelling_k07uns_k$() {
        return true;
      }
      invoke_py2q9a_k$(cause) {
        if (this._invoked_1.atomicfu$compareAndSet(false, true))
          this.handler_1(cause);
      }
    }
    initMetadataForClass($, 'InvokeOnCancelling');
    InvokeOnCancellingClass = $;
  }
  return InvokeOnCancellingClass;
}
var ResumeOnCompletionClass;
function ResumeOnCompletion() {
  if (ResumeOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(continuation) {
        super();
        this.continuation_1 = continuation;
      }
      get_onCancelling_k07uns_k$() {
        return false;
      }
      invoke_py2q9a_k$(cause) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = this.continuation_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.resumeWith_rk9gbt_k$(tmp$ret$1);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ResumeOnCompletion');
    ResumeOnCompletionClass = $;
  }
  return ResumeOnCompletionClass;
}
var ChildHandleNodeClass;
function ChildHandleNode() {
  if (ChildHandleNodeClass === VOID) {
    class $ extends JobNode() {
      constructor(childJob) {
        super();
        this.childJob_1 = childJob;
      }
      get_parent_hy4reb_k$() {
        return this.get_job_18j2r0_k$();
      }
      get_onCancelling_k07uns_k$() {
        return true;
      }
      invoke_py2q9a_k$(cause) {
        return this.childJob_1.parentCancelled_ev6cqi_k$(this.get_job_18j2r0_k$());
      }
      childCancelled_hsnipy_k$(cause) {
        return this.get_job_18j2r0_k$().childCancelled_hsnipy_k$(cause);
      }
    }
    initMetadataForClass($, 'ChildHandleNode');
    ChildHandleNodeClass = $;
  }
  return ChildHandleNodeClass;
}
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox() ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.state_1;
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
var ResumeAwaitOnCompletionClass;
function ResumeAwaitOnCompletion() {
  if (ResumeAwaitOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(continuation) {
        super();
        this.continuation_1 = continuation;
      }
      get_onCancelling_k07uns_k$() {
        return false;
      }
      invoke_py2q9a_k$(cause) {
        var state = this.get_job_18j2r0_k$().get_state_2t6sbp_k$();
        // Inline function 'kotlinx.coroutines.assert' call
        if (state instanceof CompletedExceptionally()) {
          var tmp0 = this.continuation_1;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = state.cause_1;
          var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0.resumeWith_rk9gbt_k$(tmp$ret$2);
        } else {
          var tmp0_0 = this.continuation_1;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = unboxState(state);
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          tmp0_0.resumeWith_rk9gbt_k$(tmp$ret$4);
        }
      }
    }
    initMetadataForClass($, 'ResumeAwaitOnCompletion');
    ResumeAwaitOnCompletionClass = $;
  }
  return ResumeAwaitOnCompletionClass;
}
var IncompleteStateBoxClass;
function IncompleteStateBox() {
  if (IncompleteStateBoxClass === VOID) {
    class $ {
      constructor(state) {
        this.state_1 = state;
      }
    }
    initMetadataForClass($, 'IncompleteStateBox');
    IncompleteStateBoxClass = $;
  }
  return IncompleteStateBoxClass;
}
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new (Symbol())('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new (Symbol())('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new (Symbol())('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new (Symbol())('TOO_LATE_TO_CANCEL');
    SEALED = new (Symbol())('SEALED');
    EMPTY_NEW = new (Empty())(false);
    EMPTY_ACTIVE = new (Empty())(true);
  }
}
function JobNode$invoke$ref(p0) {
  return constructCallableReference((p0_0) => {
    p0.invoke_py2q9a_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 2, 'invoke', [p0]);
}
//region block: exports
export {
  JobNode$invoke$ref as JobNode$invoke$refodp2hegnnnnc,
  get_COMPLETING_WAITING_CHILDREN as get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1,
  JobImpl as JobImpl2fbttqo93wxua,
  JobNode as JobNode2tu3g3s3xsko1,
  JobSupport as JobSupport3fdjh0rbee4be,
  unboxState as unboxStateze7t12boxn2m,
};
//endregion

//# sourceMappingURL=JobSupport.mjs.map
